module.exports = __webpack_public_path__ + "templates/campaign.html";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader?name=templates/[name].[ext]!./src/app/auth/management/campaign/campaign.html
// module id = 307
// module chunks = 15